import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import styles from './HeroSection.module.css';
import ContourBackdrop from '../../../../components/ContourBackdrop/ContourBackdrop';
import heroMark from '../../../../shared/assets/brand/hero-mark.png';
import { useIntl } from 'react-intl';

const HeroSection = () => {
	const intl = useIntl();

	return (
		<section className={styles.hero}>
			<ContourBackdrop className={styles.contours} />

			<div className={styles.inner}>
				{/* Painted before the card so the card's backdrop-filter blurs the
            part of the mark that sits underneath it. */}
				<div className={styles.markWrap} aria-hidden='true'>
					<img src={heroMark} alt='' className={styles.mark} />
				</div>

				<div className={styles.card}>
					<h1 className={styles.title}>
						{intl.formatMessage({ id: 'heroSectoinId1' })}
						<br />
						{intl.formatMessage({ id: 'heroSectoinId2' })}
					</h1>
					<p className={styles.subtitle}>
						{intl.formatMessage({ id: 'heroSectoinId3' })}
					</p>
					<Link className={styles.cta} to='/sign-up'>
						{intl.formatMessage({ id: 'heroSectoinId4' })}
						<ArrowRight size={18} strokeWidth={2.2} />
					</Link>
				</div>
			</div>
		</section>
	);
};

export default HeroSection;
